export default __webpack_public_path__ + "static/media/6.798d86a7.png";